<script setup lang="ts">
import CheckMarkIcon from '@/assets/icons/CheckMarkIcon.vue';

withDefaults(
  defineProps<{
    theme?: 'primary' | 'secondary';
    size?: 'md' | 'sm';
    styleClass?: string;
  }>(),
  {
    theme: 'secondary',
    size: 'md',
    styleClass: undefined,
  },
);
</script>

<template>
  <div
    :class="[
      'flex items-center justify-center',
      'rounded-full shrink-0',
      size === 'md' && 'size-icon-button',
      size === 'sm' && 'size-icon-sm',
      theme === 'secondary' && 'bg-surface-secondary text-secondary',
      theme === 'primary' && 'bg-primary text-white',
      styleClass,
    ]"
  >
    <CheckMarkIcon class="size-[63%]" />
  </div>
</template>
